import { Button, Modal, UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './LocationDetectModal.css';

export interface ILocationDetectModalProps {
  title: string;
  onOpenChange(open: boolean): void;
  onAgree(): void;
  onRegionChange(): void;
}

export const LocationDetectModal: React.FC<ILocationDetectModalProps> = ({
  title,
  onOpenChange,
  onAgree,
  onRegionChange,
}) => {
  return (
    <Modal
      open
      onOpenChange={onOpenChange}
      data-name="LocationDetectModal"
      size="S"
      header={<UIHeading1>{title}</UIHeading1>}
      footer={
        <div className={styles['buttons']}>
          <Button size="M" onClick={onAgree} data-name="ConfirmLocation">
            Да
          </Button>
          <Button size="M" theme="fill_secondary" onClick={onRegionChange} data-name="ChangeLocation">
            Выбрать регион
          </Button>
        </div>
      }
    />
  );
};
